import styled from "styled-components";
import { Link } from "react-router-dom";

import Container from "../../../../Components/Container";
import FlexInRow from "../../../../Components/FlexInRow";
import FlexInColumn from "../../../../Components/FlexInColumn";
import PageTitle from "../../../../Components/PageTitle";
import PageText from "../../../../Components/PageText";
import RecommendedLinks from "../../../../Components/RecommendedLinks";
import urlSlug from "url-slug";
import { Row, Col, Input, Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDay } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";

const Wrapper = styled.main`
  background-color: #ffffff;
  font-size: 16px;
  letter-spacing: 0px;
  line-height: inherit;
  text-align: center;
  width: 100%;
  margin-top: 7.813vw;

  > .content {
    padding-bottom: 4vw;
  }

  img {
    width: 100%;
  }

  .item__title {
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #0C1151;
    background: #fff;
    opacity: 1;
    display: flex;
    padding: 10px 15px;
    min-height: 70px;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .item__text {
    text-align: left;
    font-size: 1.563vw;
    line-height: 2.031vw;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-bottom: 0.729vw;
  }

  .item__cta {
    align-items: center;
    justify-content: center;
    display: flex;
    background: #0c1151 0% 0% no-repeat padding-box;
    border-radius: 0.521vw;
    opacity: 1;
    text-align: left;
    font-size: 0.938vw;
    line-height: 1.25vw;
    font-weight: bold;
    letter-spacing: 0px;
    text-decoration: none;
    color: #ffffff;
    opacity: 1;
    width: 8.021vw;
    height: 2.396vw;
    transition: 0.3s ease;
    margin-top: 1.458vw;
  }

  .item__cta:hover {
    background-color: #8688a8;
    color: #e5e5e5;
  }

  .item__date {
    text-align: left;
    font-size: 1.146vw;
    line-height: 1.51vw;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.521vw;
  }

  .item__date svg {
    font-size: 1.302vw;
  }

  #select-year {
    color: #000;
    cursour: pointer;
    z-index: 8;
  }

  @media (max-width: 992px) {
    margin-top: 120px;
  }

  @media (min-width: 1920px) {
    .item__cta {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

const Text = styled.p`
  text-align: left;
  font-size: 1.25vw;
  font-weight: bold;
  line-height: inherit;
  letter-spacing: 0px;
  color: #0c1151;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0;

  @media (max-width: 992px) {
    font-size: 2.222vw;
    line-height: 3.333vw;
  }
`;

const SectionCards = styled.div`
  display: grid;
  grid-column-gap: 2.656vw;
  grid-row-gap: 3.021vw;
  grid-template-columns: 1fr 1fr 1fr;

  .item {
    border: 0.156vw solid #0c1151;
    border-top: 0.625vw solid #0c1151;
    border-radius: 0px 0px 1.042vw 1.042vw;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    text-decoration: none;
    justify-content: space-between;
  }

  .item__image img {
      object-fit: cover;
  }

  .item__image {
    border: none;
    overflow: hidden;
    position: relative;
    height: 200px;

    picture {
      z-index: 1;
      object-fit: cover;
    }

    .overlay {
      background: transparent
        linear-gradient(180deg, #452aa71a 0%, #452aa720 100%) 0% 0% no-repeat
        padding-box;
      height: 100%;
      width: 100%;
      position: absolute;
      top: 0;
      z-index: 2;
    }

    img {
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  .item__cta {
    align-items: center;
    justify-content: center;
    display: flex;
    background-color: #0c1151;
    border: none;
    border-radius: 0;
    opacity: 1;
    text-align: left;
    font-size: 0.938vw;
    line-height: 1.25vw;
    font-weight: bold;
    letter-spacing: 0px;
    text-decoration: none;
    color: #ffffff;
    opacity: 1;
    width: 100%;
    height: 2.396vw;
    transition: 0.3s ease;
    margin: 0;
  }

  .item:hover .item__cta {
    background-color: #8688a8;
    color: #e5e5e5;
  }

  @media (max-width: 992px) {
    grid-template-columns: 1fr;

    .item__image {
      height: 260px;
    }

    .item__cta {
      font-size: 16px;
      line-height: 22px;
      padding: 20px 0;
    }
  }

  @media (min-width: 1920px) {
    .item__cta {
      font-size: 18px;
      line-height: 24px;
    }
  }
`;
const Picture = styled.picture`
  min-width: ${(props) => props.width};
  max-width: ${(props) => props.width};
x
  @media (max-width: 992px) {
    max-width: 150px;
  }
`;

export default function FormacaoOnline(props) {
  const session_storage = JSON.parse(localStorage.getItem("session_data"));
  const [apresentacoes, setApresentacoes] = useState([]);
  const tipoUtilizador =
    session_storage?.all_data?.user_session?.tipo_utilizador || null;

  const isAdmin = tipoUtilizador == "admin";
  const isSocio = tipoUtilizador == "socio_aprovado";
  const isNaoSocio = tipoUtilizador == "nao_socio";
  const isNaoRegistado = !tipoUtilizador;
  const [searchTitulo, setSearchTitulo] = useState("");
const [categoriaFiltro, setCategoriaFiltro] = useState(null);
const [categorias, setCategorias] = useState([]);

  const podeVerApresentacao = (item) => {
    const nenhumAtivo =
      item.show_socios == 0 &&
      item.show_nao_socios == 0 &&
      item.show_nao_registados == 0;

    // Se nenhum switch estiver ativo → mostrar a todos
    if (isAdmin || nenhumAtivo) return true;

    if (isSocio && item.show_socios == 1) return true;
    if (isNaoSocio && item.show_nao_socios == 1) return true;
    if (isNaoRegistado && item.show_nao_registados == 1) return true;

    return true;
  };

  const getApresentacoes = (allApresentacoes) => {

  // 🔹 Hoje sem horas
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  allApresentacoes = allApresentacoes
    .filter((a) => a.formacao_online == 1)
    .filter((a) => {
      let startValido = true;
      let endValido = true;
      let podeVer = podeVerApresentacao(a);

      if (a.start_post && a.start_post?.length == 10 && a.start_post != 'null') {
        const [d, m, y] = a.start_post.split("/");
        const startDate = new Date(y, m - 1, d);
        startDate.setHours(0, 0, 0, 0);
        startValido = startDate <= hoje;
      }

      if (a.end_post && a.end_post?.length == 10 && a.end_post != 'null') {
        const [d, m, y] = a.end_post.split("/");
        const endDate = new Date(y, m - 1, d);
        endDate.setHours(0, 0, 0, 0);
        endValido = endDate >= hoje;
      }

      return startValido && endValido && podeVer;
    });

  if (allApresentacoes?.length > 0) {
    allApresentacoes.forEach((apresentacao) => {
      if (
        !apresentacao.external_link ||
        apresentacao.external_link === "undefined"
      ) {
        apresentacao.slug =
          "https://spap.pt/ferramentas-uteis/formacao/formacao-online/" +
          urlSlug(apresentacao.titulo) +
          "-" +
          apresentacao.id;
      } else {
        apresentacao.slug = apresentacao.external_link;
      }
    });
  }

  const apresentacoesOrdenadas = allApresentacoes.sort(
    (a, b) => a.ordem - b.ordem
  );

  const categoriasUnicas = [
    ...new Set(
      allApresentacoes
        ?.map((a) => a.categoria)
        .filter((c) => c && c.trim() !== "")
    ),
  ];

  setCategorias(categoriasUnicas);

  setApresentacoes(apresentacoesOrdenadas);
};

  
    useEffect(() => {
      fetch(`https://api.spap.pt/api/all-apresentacoes`, {
        method: "GET",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Erro ao buscar apresentacoes");
          }
          return response.json();
        })
        .then((data) => {
          if (data.length === 0) {
            setNoResults("Não há conteúdo Destaques no momento");
            console.log("nenhum evento");
          }
          getApresentacoes(data.apresentacoes);
        })
        .catch((error) => console.error(error));
    }, []);

  const apresentacoesFiltradas = apresentacoes.filter((item) => {
    const matchTitulo =
      item.titulo?.toLowerCase().includes(searchTitulo.toLowerCase());

    const matchCategoria = categoriaFiltro
      ? item.categoria === categoriaFiltro
      : true;

    return matchTitulo && matchCategoria;
  });
  
  return (
    <Wrapper>
      <Container className="content">
        <PageTitle
          title="Formação Online"
          path={[
            {
              text: "Homepage",
              link: "/",
            },
            {
              text: "Ferramentas úteis",
              link: "/ferramentas-uteis",
            },
            {
              text: "Formação",
              link: "/ferramentas-uteis/formacao",
            },
            {
              text: "Formação Online",
            },
          ]}
          imageDesktop={require("../../../../Assets/Images/img-top-agenda@2x.png")}
          imageMobile={require("../../../../Assets/Images/img-top-agenda.png")}
        />

        <FlexInRow gap="3.542vw">
                      <PageText title="" />
        
        
                          {/* #TODO Inserir conteudo de titulo e texto aqui
                          <div>
                            <Text>Ut enim ad minim veniam, quis nostrud exercitation ul.</Text>
                            <Text>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore (…)</Text>
                          </div>
                  */}
                
                          {apresentacoes.length > 0 && (
                            <>
                            <Row
                              gutter={[16, 16]}
                              align="middle"
                              justify="end"
                              style={{ marginBottom: "10px" }}
                            >
                              <Col xs={24} md={8} align={'left'}>
                                <span style={{ fontWeight: 600, color: "#0C1151", textAlign: 'left' }}>
                                  Pesquise aqui a formação a partir do nome ou categoria
                                </span>
                              </Col>

                              <Col xs={24} md={8}>
                                <Input
                                  placeholder="Nome da formação"
                                  value={searchTitulo}
                                  onChange={(e) => setSearchTitulo(e.target.value)}
                                  style={{ width: "100%", height: 35 }}
                                />
                              </Col>
                            {categorias?.length > 0 && (
                              <Col xs={24} md={8}>
                                <Select
                                  placeholder="Selecionar categoria"
                                  allowClear
                                  value={categoriaFiltro}
                                  onChange={(value) => setCategoriaFiltro(value)}
                                  style={{ width: "100%", height: 35 }}
                                  options={categorias.map((cat) => ({
                                    label: cat,
                                    value: cat,
                                  }))}
                                />
                              </Col>
                            )}
                            </Row>
                            <SectionCards>
                              {apresentacoesFiltradas.map((item, index) => {
                                return (
                                  <Link to={item.slug} className={"item item-" + index}>
                                    <div className="item__content">
                                      <div className="item__image">
                                          <img src={"https://api.spap.pt/apresentacoes/" + item.id + "/" + item.imagem_destaque} alt={item.titulo} />
                                      </div>
                                      <div className="item__title">
                                        {item.titulo}
                                      </div>
                                    </div>
                                    <div className="item__cta">Saber mais</div>
                                  </Link>
                                );
                              })}
                            </SectionCards>
                            </>
                          )}
                        </FlexInRow>
      </Container>

      <RecommendedLinks
        title="PODERÁ TER INTERESSE EM VISITAR AS PÁGINAS:"
        links={[
          {
            title: "História",
            link: "/spap/historia",
          },
          {
            title: "Órgãos sociais",
            link: "/spap/orgaos-sociais",
          },
          {
            title: "Bolsas e prémios",
            link: "/spap/bolsas-e-premios",
          },
          {
            title: "Vantagens de ser sócio",
            link: "/socios/conheca-as-vantagens",
          },
        ]}
      />
    </Wrapper>
  );
}
